import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  TablePagination,
  createTheme,
  Dialog, DialogTitle, DialogActions, DialogContent,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
  CardMedia,
  Select,
  Chip,
  InputAdornment,
  Checkbox
} from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@mui/icons-material/Search';
import AlertScreen from 'src/components/Alert';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import trLocale from 'date-fns/locale/tr';
import { styled } from '@mui/system';
import { getUser } from 'src/utils/Common';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import SaveIcon from '@material-ui/icons/Save';
import { Autocomplete, createFilterOptions, Box, Typography } from '@mui/material';
import ReceiptDetail from 'src/views/IndividualProductInquiry/receiptDetail';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AttachmentIcon from '@material-ui/icons/Attachment';
import TuneIcon from '@mui/icons-material/Tune';
import FileData from 'src/components/Photo'
import DosyaYonetimiDialog from 'src/components/FolderManagementDialog';
import moment from 'moment';
import * as XLSX from 'xlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    position: 'relative',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000, // ÖNEMLİ: Card ve diğer öğelerin üstünde olması için
    color: '#fff',
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});

const basvuruNedeniFilterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
});


function UnregisteredReturns() {
  const classes = useStyles();
  const SessionUser = getUser();

  const [Alert, setAlert] = useState(false);
  const [AlertType, setAlertType] = useState('');
  const [ResponseMessage, setResponseMessage] = useState('');
  const [Loading, setLoading] = useState(false);
  const [UnregisteredReturnsData, setUnregisteredReturnsData] = useState([]);
  const [UnregisteredReturnsSearchData, setUnregisteredReturnsSearchData] = useState([]);
  const [PopupDurum, setPopupDurum] = useState(false);
  const [PopupFis, setPopupFis] = useState(false);
  const [Id, setId] = useState(0);
  const [Aktif, setAktif] = useState(1);
  const [Aciklama, setAciklama] = useState('');
  const [DetayAciklama, setDetayAciklama] = useState('');
  const [Durum, setDurum] = useState(0);
  const [search, setSearch] = React.useState('');
  const [FisNo, setFisNo] = useState(0);
  const [Notlar, setNotlar] = useState('');
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const [PopupFile, setPopupFile] = useState(false);
  const [SelectedBasvuruNedeni, setSelectedBasvuruNedeni] = useState([]);
  const [SelectedDurumFilter, setSelectedDurumFilter] = useState([]);
  const [SelectedNakliyeDurum, setSelectedNakliyeDurum] = useState([]);
  const [BaslangicTarihi, setBaslangicTarihi] = useState(null);
  const [BitisTarihi, setBitisTarihi] = useState(null);
  const [NakliyeDurumOptions, setNakliyeDurumOptions] = useState([]);
  const [BasvuruNedeniOptions, setBasvuruNedeniOptions] = useState([]);
  const [DurumFilterOptions, setDurumFilterOptions] = useState([]);
  const [ExportLoading, setExportLoading] = useState(false);
  const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('UST_BIRIM_KODU');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getBolgeAdiKoduData();
    getNakliyeDurumData();
    getBasvuruNedeniData();
    getDurumFilterData();
  }, []);

  const getNakliyeDurumData = () => {
    axios.get(`GetFisNakliyeDurumlari`).then((response) => {
      const mapped = response.data.map(item => ({ label: item.ACIKLAMA, value: item.DURUM }));
      setNakliyeDurumOptions(mapped);
      const tumuOption = mapped.find(x => x.value === 0);
      if (tumuOption) setSelectedNakliyeDurum([tumuOption]);
    });
  };

  const getBasvuruNedeniData = () => {
    axios.get(`GetFisBasvuruNedenleri`).then((response) => {
      const options = response.data.map(item => ({ label: item.ACIKLAMA, value: item.ID }));
      setBasvuruNedeniOptions(options);
      const tumuOption = options.find(x => x.value === 0);
      if (tumuOption) setSelectedBasvuruNedeni([tumuOption]);
    });
  };

  const getDurumFilterData = () => {
    axios.get(`GetFisDurumlari`).then((response) => {
      const options = response.data.map(item => ({ label: item.ACIKLAMA, value: item.DURUM }));
      setDurumFilterOptions(options);
      const tumuOption = options.find(x => x.value === 0);
      if (tumuOption) setSelectedDurumFilter([tumuOption]);
    });
  };

  const setPopupDurumOpen = (FisNo, NAKLIYE_DURUM, NOTLAR) => {
    setDurum(NAKLIYE_DURUM);
    setNotlar(NOTLAR); // Notlar alanını güncel bilgisini getireceğiz.
    setFisNo(FisNo);
    setPopupDurum(true);
  }
  const setPopupFileOpen = (FisNo) => {
    setFisNo(FisNo);
    setPopupFile(true);
  }

  const handleFisNoClick = (FisNo) => {
    setFisNo(FisNo);
    setPopupFis(true);
  }

  const handleSave = () => {

    if (Durum === 0 || Durum === "") {
      setResponseMessage("Lütfen Durum Seçiniz!");
      setAlert(true);
      setAlertType("error");
      return;
    }

    setLoading(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      FisNo: FisNo,
      Durum: Durum,
      Notlar: Notlar,
      UserId: SessionUser?.UserId
    };

    axios.post('/SetApolloUnregisteredReturns', requestData, config)
      .then(response => {
        var data = response.data;
        setResponseMessage(data.ErrorDescription);
        setAlert(true);
        setAlertType(data.ErrorCode === "1000" ? "error" : "success");
        getUnregisteredReturnsData(0);
        setDurum(0);
        setNotlar('');
        setFisNo(0);
        setPopupDurum(false);
      });
    setLoading(false);
  }

  const getUnregisteredReturnsData = () => {
    if (!selectedbolgeAdiKodu || selectedbolgeAdiKodu.BirimKodu === undefined) {
      setResponseMessage('Lütfen Bölge Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (!SelectedBirim || SelectedBirim.length === 0) {
      setResponseMessage('Lütfen Servis Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (SelectedBasvuruNedeni.length === 0) {
      setResponseMessage('Lütfen Başvuru Nedeni Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (SelectedDurumFilter.length === 0) {
      setResponseMessage('Lütfen Durum Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (SelectedNakliyeDurum.length === 0) {
      setResponseMessage('Lütfen Nakliye Durumu Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (!BaslangicTarihi) {
      setResponseMessage('Lütfen Başlangıç Tarihi Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    if (!BitisTarihi) {
      setResponseMessage('Lütfen Bitiş Tarihi Seçiniz!');
      setAlert(true); setAlertType('error'); return;
    }
    setLoading(true);
    const startDate = BaslangicTarihi ? moment(BaslangicTarihi).format('YYYY-MM-DD') : '';
    const endDate = BitisTarihi ? moment(BitisTarihi).format('YYYY-MM-DD') : '';
    axios.get(`/GetApolloUnregisteredReturns/${selectedbolgeAdiKodu?.BirimKodu}/${SelectedBirim.map(x => x.BirimKodu).join(',')}/${SelectedBasvuruNedeni.map(x => x.value).join(',')}/${SelectedDurumFilter.map(x => x.value).join(',')}/${SelectedNakliyeDurum.map(x => x.value).join(',')}/${startDate}/${endDate}`)
      .then((response) => {
        const res = response.data;
        setUnregisteredReturnsData(res);
        setUnregisteredReturnsSearchData(res);

      })
      .catch((error) => {

      })
      .finally(() => {
        setLoading(false);
      });

  }

  const handleSearch = async (event) => {
    const newString = event?.target.value;
    setSearch(newString);
    if (newString) {
      const lowercasedNewString = newString.toLowerCase('tr-TR');
      const filteredData = UnregisteredReturnsSearchData.filter(item => {
        const concatenatedStr = `${item.UST_BIRIM_KODU ?? ''} ${item.BOLGE ?? ''} ${item.KUL_BIRIM_KODU ?? ''} ${item.SERVIS ?? ''} 
        ${item.BASVURU_NEDENI ?? ''}  ${item.DURUM ?? ''} ${item.ANA_GRUP ?? ''} ${item.KUL_MODEL_KODU ?? ''} 
        ${item.MODEL ?? ''}${item.ADI ?? ''}${item.SOYADI ?? ''}${item.FIS_NO ?? ''}`;
        const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
        return lowercasedConcatenatedStr.includes(lowercasedNewString);
      });
      setUnregisteredReturnsData(filteredData);
    } else {
      setUnregisteredReturnsData(UnregisteredReturnsSearchData);
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = UnregisteredReturnsData.slice().sort((a, b) => {
    if (!orderBy) return 0;

    const aValue = a[orderBy];
    const bValue = b[orderBy];

    const dateFields = ['CAGRI_TARIHI'];
    const isDate = dateFields.includes(orderBy);

    if (isDate) {
      const format = 'DD.MM.YYYY HH:mm';
      const dateA = moment(aValue, format);
      const dateB = moment(bValue, format);
      return order === 'asc' ? dateA - dateB : dateB - dateA;
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return order === 'asc' ? aValue - bValue : bValue - aValue;
    }

    return order === 'asc'
      ? aValue?.toString().localeCompare(bValue?.toString())
      : bValue?.toString().localeCompare(aValue?.toString());
  });


  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      const bolgeData = response?.data ?? [];
      setBolgeAdiKodu(bolgeData);
      const tumuOption = bolgeData.find(x => Number(x.BirimKodu) === 0);
      if (tumuOption) {
        setSelectedbolgeAdiKodu(tumuOption);
        getBirimData(tumuOption.BirimKodu);
      }
    })

  }

  const getBirimData = (BirimKodu) => {
    setLoading(true);
    axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu}`).then((response) => {
      setBirimData([SelectAllOption, ...response.data]);
      setSelectedBirim([SelectAllOption]);
      setLoading(false);
    });
  }

  const exportToExcel = () => {
    setExportLoading(true);
    setTimeout(() => {
      try {
        const columns = [
          { key: 'UST_BIRIM_KODU', header: 'Bölge Kodu' },
          { key: 'BOLGE', header: 'Bölge' },
          { key: 'KUL_BIRIM_KODU', header: 'Servis Kodu' },
          { key: 'SERVIS', header: 'Servis' },
          { key: 'FIS_NO', header: 'FişNo' },
          { key: 'CAGRI_TARIHI', header: 'Çağrı Tarihi' },
          { key: 'BASVURU_NEDENI', header: 'Başvuru Nedeni' },
          { key: 'DURUM', header: 'Durum' },
          { key: 'NAKLIYE_DURUM_ACIKLAMA', header: 'Nakliye Durum' },
          { key: 'ANA_GRUP', header: 'Ürün Grubu' },
          { key: 'KUL_MODEL_KODU', header: 'Ürün Kodu' },
          { key: 'MODEL', header: 'Ürün' },
          { key: 'ADI', header: 'Adı' },
          { key: 'SOYADI', header: 'Soyadı' },
        ];
        const data = UnregisteredReturnsData.map(item =>
          columns.reduce((row, col) => { row[col.header] = item[col.key] ?? ''; return row; }, {})
        );
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Kayıt Dışı İadeler');
        XLSX.writeFile(wb, `KayitDisiIade_${moment().format('YYYYMMDD_HHmm')}.xlsx`);
        setResponseMessage(`${UnregisteredReturnsData.length} kayıt başarıyla Excel'e aktarıldı.`);
        setAlertType('success');
        setAlert(true);
      } catch (e) {
        setResponseMessage('Excel aktarımı sırasında bir hata oluştu.');
        setAlertType('error');
        setAlert(true);
      } finally {
        setExportLoading(false);
      }
    }, 100);
  };

  const renderOption = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>
  );

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Alert}
        autoHideDuration={10000}
        onClose={event => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <AlertScreen
          onClose={event => setAlert(false)}
          variant={AlertType}
          message={ResponseMessage}
        ></AlertScreen>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Kayıt Dışı İade Yönetimi"

          />
          <Divider />
          <CardContent sx={{ pb: '12px !important' }}>
            <Box
              sx={{
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                p: 2,
                backgroundColor: '#fafafa',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                <TuneIcon sx={{ color: '#FF9800', fontSize: 20 }} />
                <Typography
                  variant="subtitle2"
                  sx={{ color: '#616161', fontWeight: 700, fontSize: 12, letterSpacing: 0.8, textTransform: 'uppercase' }}
                >
                  Filtreler
                </Typography>
              </Box>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} sm={6} lg={3}>
                  <Autocomplete
                    limitTags={1}
                    size="small"
                    fullWidth
                    value={selectedbolgeAdiKodu}
                    options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    renderOption={renderOption}
                    onChange={(event, newValue) => {
                      setSelectedbolgeAdiKodu(newValue);
                      if (newValue) {
                        getBirimData(newValue.BirimKodu);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bölge"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 }
                        }}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    size="small"
                    fullWidth
                    disableCloseOnSelect
                    value={SelectedBirim}
                    options={BirimData.length > 0 ? BirimData : []}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    isOptionEqualToValue={(option, value) => Number(option.BirimKodu) === Number(value.BirimKodu)}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.Dsc}
                      </li>
                    )}
                    onChange={(event, newValue) => {
                      setSelectedBirim(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Servis"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 }
                        }}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    size="small"
                    fullWidth
                    value={SelectedBasvuruNedeni}
                    options={BasvuruNedeniOptions}
                    disableCloseOnSelect
                    getOptionLabel={(option) => (option.label ? option.label : '')}
                    isOptionEqualToValue={(option, value) =>
                      option.value !== undefined
                        ? option.value === value.value
                        : option.id === value.id
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, newValue) => setSelectedBasvuruNedeni(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Başvuru Nedeni"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 }
                        }}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    size="small"
                    fullWidth
                    disableCloseOnSelect
                    value={SelectedDurumFilter}
                    options={DurumFilterOptions}
                    getOptionLabel={(option) => (option.label ? option.label : '')}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, newValue) => setSelectedDurumFilter(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Durum"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 }
                        }}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    size="small"
                    fullWidth
                    disableCloseOnSelect
                    value={SelectedNakliyeDurum}
                    options={NakliyeDurumOptions}
                    getOptionLabel={(option) => (option.label ? option.label : '')}
                    isOptionEqualToValue={(option, value) =>
                      option.value !== undefined
                        ? option.value === value.value
                        : option.id === value.id
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, newValue) => setSelectedNakliyeDurum(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Nakliye Durumu"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 }
                        }}
                      />
                    )}
                    sx={{
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={trLocale}>
                    <DatePicker
                      label="Başlangıç Tarihi"
                      format="dd.MM.yyyy"
                      value={BaslangicTarihi}
                      onChange={(date) => setBaslangicTarihi(date)}
                      sx={{ width: '100%' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={trLocale}>
                    <DatePicker
                      label="Bitiş Tarihi"
                      format="dd.MM.yyyy"
                      value={BitisTarihi}
                      onChange={(date) => setBitisTarihi(date)}
                      sx={{ width: '100%' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: '40px' }}
                    sx={{ fontWeight: 600, fontSize: 14 }}
                    onClick={(event) => getUnregisteredReturnsData()}
                    endIcon={<SearchIcon>Search</SearchIcon>}
                  >
                    Sorgula
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
          <Divider />
          <CardContent sx={{ px: 2.5, pt: '14px !important', pb: '0 !important' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1.5,
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#8C8C8C',
                  fontWeight: 400,
                  letterSpacing: 0.1,
                }}
              >
                <Box component="span" sx={{ fontWeight: 600, color: '#1A1A1A' }}>
                  {UnregisteredReturnsData.length}
                </Box>
                {' kayıt listelendi'}
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <OutlinedInput
                  id="input-search-card-style1"
                  placeholder="Tabloda ara..."
                  value={search}
                  onChange={handleSearch}
                  autoComplete="on"
                  size="small"
                  sx={{
                    height: 36,
                    fontSize: 13,
                    fontWeight: 400,
                    width: { xs: 160, sm: 220 },
                    borderRadius: '10px',
                    backgroundColor: '#FAFAFA',
                    color: '#1A1A1A',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#E4E4E7',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#C4C4C7',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#A1A1AA',
                      borderWidth: '1px',
                    },
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 15, color: '#A1A1AA' }} />
                    </InputAdornment>
                  }
                />
                <Button
                  onClick={exportToExcel}
                  disabled={ExportLoading || UnregisteredReturnsData.length === 0}
                  startIcon={
                    ExportLoading
                      ? <CircularProgress size={13} sx={{ color: 'inherit' }} />
                      : <FileDownloadIcon sx={{ fontSize: '16px !important' }} />
                  }
                  sx={{
                    height: 36,
                    px: 2,
                    borderRadius: '10px',
                    backgroundColor: '#217346',
                    color: '#fff',
                    fontSize: 13,
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    textTransform: 'none',
                    letterSpacing: 0.2,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'all 0.18s ease',
                    '& .MuiButton-startIcon': { mr: { xs: 0, sm: '6px' }, ml: 0 },
                    '&:hover': {
                      backgroundColor: '#1a5c38',
                      boxShadow: '0 3px 10px rgba(33,115,70,0.25)',
                      transform: 'translateY(-1px)',
                    },
                    '&:active': {
                      backgroundColor: '#145230',
                      boxShadow: 'none',
                      transform: 'translateY(0)',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#E4E4E7',
                      color: '#A1A1AA',
                      boxShadow: 'none',
                    },
                  }}
                >
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    {ExportLoading ? 'Aktarılıyor...' : 'Excel\'e Aktar'}
                  </Box>
                </Button>
              </Box>
            </Box>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'UST_BIRIM_KODU'}
                        direction={orderBy === 'UST_BIRIM_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('UST_BIRIM_KODU')}
                      >
                        Bölge Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'BOLGE'}
                        direction={orderBy === 'BOLGE' ? order : 'asc'}
                        onClick={() => handleRequestSort('BOLGE')}
                      >
                        Bölge
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KUL_BIRIM_KODU'}
                        direction={orderBy === 'KUL_BIRIM_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('KUL_BIRIM_KODU')}
                      >
                        Servis Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'SERVIS'}
                        direction={orderBy === 'SERVIS' ? order : 'asc'}
                        onClick={() => handleRequestSort('SERVIS')}
                      >
                        Servis
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'FIS_NO'}
                        direction={orderBy === 'FIS_NO' ? order : 'asc'}
                        onClick={() => handleRequestSort('FIS_NO')}
                      >
                        FişNo
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'CAGRI_TARIHI'}
                        direction={orderBy === 'CAGRI_TARIHI' ? order : 'asc'}
                        onClick={() => handleRequestSort('CAGRI_TARIHI')}
                      >
                        Çagrı Tarihi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'BASVURU_NEDENI'}
                        direction={orderBy === 'BASVURU_NEDENI' ? order : 'asc'}
                        onClick={() => handleRequestSort('BASVURU_NEDENI')}
                      >
                        Başvuru Nedeni
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'DURUM'}
                        direction={orderBy === 'DURUM' ? order : 'asc'}
                        onClick={() => handleRequestSort('DURUM')}
                      >
                        Durum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'NAKLIYE_DURUM'}
                        direction={orderBy === 'NAKLIYE_DURUM' ? order : 'asc'}
                        onClick={() => handleRequestSort('NAKLIYE_DURUM')}
                      >
                        Nakliye Durum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'ANA_GRUP'}
                        direction={orderBy === 'ANA_GRUP' ? order : 'asc'}
                        onClick={() => handleRequestSort('ANA_GRUP')}
                      >
                        Ürün Grubu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KUL_MODEL_KODU'}
                        direction={orderBy === 'KUL_MODEL_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('KUL_MODEL_KODU')}
                      >
                        Ürün Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'MODEL'}
                        direction={orderBy === 'MODEL' ? order : 'asc'}
                        onClick={() => handleRequestSort('MODEL')}
                      >
                        Ürün
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'ADI'}
                        direction={orderBy === 'ADI' ? order : 'asc'}
                        onClick={() => handleRequestSort('ADI')}
                      >
                        Adı
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'SOYADI'}
                        direction={orderBy === 'SOYADI' ? order : 'asc'}
                        onClick={() => handleRequestSort('SOYADI')}
                      >
                        Soyadı
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Dosya</TableCell>
                    <TableCell>Düzenle</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    paginatedData.map((item) => (
                      <TableRow hover key={item.FIS_NO}>
                        <TableCell>{item.UST_BIRIM_KODU}</TableCell>
                        <TableCell title={item.BOLGE}>{item.BOLGE.substring(0, 6)}...</TableCell>
                        <TableCell>{item.KUL_BIRIM_KODU}</TableCell>
                        <TableCell title={item.SERVIS}>{item.SERVIS.substring(0, 10)}...</TableCell>
                        <TableCell>
                          <span
                            style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleFisNoClick(item.FIS_NO)}
                          >
                            {item.FIS_NO}
                          </span>
                        </TableCell>
                        <TableCell>{item.CAGRI_TARIHI}</TableCell>
                        <TableCell title={item.BASVURU_NEDENI}>{item.BASVURU_NEDENI.substring(0, 6)}...</TableCell>
                        <TableCell>{item.DURUM}</TableCell>
                        <TableCell>{item.NAKLIYE_DURUM_ACIKLAMA}</TableCell>
                        <TableCell>{item.ANA_GRUP}</TableCell>
                        <TableCell>{item.KUL_MODEL_KODU}</TableCell>
                        <TableCell title={item.MODEL}>{item.MODEL.substring(0, 10)}...</TableCell>
                        <TableCell>{item.ADI}</TableCell>
                        <TableCell>{item.SOYADI}</TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => setPopupFileOpen(item.DOSYA_FIS_NO)}
                            aria-label="settings">
                            <AttachmentIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => setPopupDurumOpen(item.FIS_NO, item.NAKLIYE_DURUM, item.NOTLAR)}
                            aria-label="settings">
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={UnregisteredReturnsData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={PopupFis}
        fullWidth
        maxWidth="xl"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Fiş Detayı</DialogTitle>
        <Divider />
        <DialogContent>
          <ReceiptDetail ReceiptNumber={FisNo} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupFis(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={PopupDurum}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Durum Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                disabled
                fullWidth
                id="outlined-disabled"
                label="FişNo"
                defaultValue={FisNo}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Durum</InputLabel>
                <Select
                  label="Durum"
                  variant='outlined'
                  value={Durum}
                  onChange={(e) => setDurum(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Nakliye Durum Seçiniz!...</MenuItem>
                  {NakliyeDurumOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                fullWidth
                id="outlined-disabled"
                label="Başvuru Notu"
                defaultValue={Notlar}
                variant="outlined"
                multiline
                minRows={4}
                onChange={(e) => setNotlar(e.target.value)}
              />
            </Grid>

          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { handleSave() }}
            endIcon={<SaveIcon />}
          >
            Kaydet
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupDurum(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={PopupFile}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Dosya Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <DosyaYonetimiDialog FisNo={FisNo} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupFile(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}
export default UnregisteredReturns;
